import moment from "moment";
export function localTimeToUtc(time) {
   var currentDate = moment.utc(time).format("YYYY-MM-DD")
     time = moment.utc(time).format("HH:mm:ss")
    time = currentDate + " " + time
    time = moment.utc(moment(time, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss'))
    return time;
}
